/**
 * @generated SignedSource<<497b8c138368400cc4333eaf32cea77a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SuspendedPageSetOrganizationSuspendedMutation$variables = {
  suspendedAt?: any | null | undefined;
};
export type SuspendedPageSetOrganizationSuspendedMutation$data = {
  readonly setOrganizationSuspended: {
    readonly error: {
      readonly message: string;
    } | null | undefined;
    readonly success: {
      readonly organization: {
        readonly id: any;
        readonly isSuspended: boolean;
        readonly suspendedAt: any | null | undefined;
      };
    } | null | undefined;
  };
};
export type SuspendedPageSetOrganizationSuspendedMutation = {
  response: SuspendedPageSetOrganizationSuspendedMutation$data;
  variables: SuspendedPageSetOrganizationSuspendedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suspendedAt"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "suspendedAt",
        "variableName": "suspendedAt"
      }
    ],
    "concreteType": "SetOrganizationSuspendedResponse",
    "kind": "LinkedField",
    "name": "setOrganizationSuspended",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SetOrganizationSuspendedSuccess",
        "kind": "LinkedField",
        "name": "success",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSuspended",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspendedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SetOrganizationSuspendedError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SuspendedPageSetOrganizationSuspendedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SuspendedPageSetOrganizationSuspendedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "804dbaa85219f43adfb75a2c6f0b13b7",
    "id": null,
    "metadata": {},
    "name": "SuspendedPageSetOrganizationSuspendedMutation",
    "operationKind": "mutation",
    "text": "mutation SuspendedPageSetOrganizationSuspendedMutation(\n  $suspendedAt: DateTime\n) {\n  setOrganizationSuspended(suspendedAt: $suspendedAt) {\n    success {\n      organization {\n        id\n        isSuspended\n        suspendedAt\n      }\n    }\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a064888c70faf90221fcff3b033bfe6";

export default node;
